import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlantillasService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'plantillas'); // La URL base para el servicio de usuarios
  }

  /** PLANTILLAS */
  getPlantillas(page: number, limit: number) {
    return this.get<any[]>({
      endpoint: `?page=${page}&limit=${limit}`,
      trackLoading: true, // 👈 loader
    });
  }

  addPlantilla(body: any): Observable<any> {
    return this.post<any>(body, '', undefined, true); // 👈 loader
  }

  updPlantilla(body: any, idPlantilla: number): Observable<any> {
    return this.put<any>(body, `${idPlantilla}`, undefined, true); // 👈 loader
  }

  activarPlantilla(idPlantilla: number): Observable<any> {
    return this.patch<any>(null, `${idPlantilla}/restore`); // 👈 loader
  }

  /** DOCUMENTO PLANTILLAS */
  addDocumenPlantilla(idPlantilla: number, body: any): Observable<any> {
    return this.put<any>(body, `${idPlantilla}/documentos`, undefined, true); // 👈 loader
  }

  showDocumenPlantilla(idPlantilla: number): Observable<any> {
    return this.get<any>({
      endpoint: `${idPlantilla}`,
      trackLoading: true, // 👈 loader
    });
  }

  viewDocumenPlantilla(idPlantilla: number): Observable<any> {
    return this.get<any>({
      endpoint: `documentos/${idPlantilla}`,
      trackLoading: true, // 👈 loader
    });
  }

  deleteDocumentPlantilla(idPlantilla: number) {
    return this.delete<any>(`${idPlantilla}`, undefined, undefined, true); // 👈 loader
  }

  deletePlantilla(idPlantilla: number) {
    return this.delete<any>(`${idPlantilla}/data`, undefined, undefined, true); // 👈 loader
  }

  /** COORDENADAS PLANTILLAS */
  addCoordenadasPlantilla(body: any, idPlantilla: number): Observable<any> {
    return this.post<any>(body, `${idPlantilla}/coordenadas`, undefined, true); // 👈 loader
  }

  getCordenadasPlantilla(idCoordenadas: number) {
    return this.get<any>({
      endpoint: `${idCoordenadas}/coordenadas`,
      trackLoading: true, // 👈 loader
    });
  }

  deleteCoordenada(idPlantilla: number, idPlantillaCoordenada: number) {
    return this.delete<any>(
      `${idPlantilla}/coordenadas/${idPlantillaCoordenada}`,
      undefined,
      undefined,
      true // 👈 loader
    );
  }
}
